import { Line } from 'react-chartjs-2';
import {Chart, registerables} from 'chart.js'; 
import 'chartjs-adapter-date-fns';
import { format } from 'date-fns';

Chart.register(...registerables);


function LineChart({ data, options }) {

  if (!data) {
    return null;
  }

  const chartData = {
    labels: Object.keys(data),
    datasets: [
      {
        label: 'Number of Registered Users',
        data: Object.values(data),
        fill: false,
        backgroundColor: 'rgb(255, 99, 132)',
        borderColor: 'rgba(255, 99, 132, 0.2)',
      },
    ],
  };

  return <Line data={chartData} options={options} key={JSON.stringify(data)} />;
}  
export default LineChart;
